import { getUserFeedbackFile } from '../../../services/userFeedbackService';

import type { CarouselSource } from './carouselMedia';

export function userFeedbackCarouselSource(feedbackId: number): CarouselSource {
  return {
    load: async item => {
      const file = await getUserFeedbackFile(feedbackId, Number(item.id));
      if (!file.fileData) {
        throw new Error('That file was not found.');
      }
      return {
        base64: file.fileData,
        mimeType: file.mimeType || 'application/octet-stream',
      };
    },
  };
}
